

































import Vue from 'vue'
import { mdiCheckBoxOutline } from '@mdi/js'
import { BaseBtnSubmitPayment } from '@/components'
import { IPaymentMethod, IShipping } from '@/models'
import { getFormattedPrice } from '@/utils'
import { Location } from 'vue-router'
import { ROUTES } from '@/enums'

export default Vue.extend({
    name: 'OrderActions',

    components: { BaseBtnSubmitPayment },

    data: () => ({
        isConsentChecked: false,
        mdiCheckBoxOutline,
    }),

    props: {
        orderCode: {
            type: String,
            required: true,
        },
        paymentMethod: Object as () => IPaymentMethod,
        shipping: Object as () => IShipping,
    },

    computed: {
        price(): string {
            if (!this.shipping) return ''

            return getFormattedPrice(this.shipping.price)
        },

        termsOfUseRoute(): Location {
            return { name: ROUTES.TERMS_OF_USE }
        },
    },
})
